import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode } from "react";

export const Icon = styled(FontAwesomeIcon)`
  cursor: pointer;
`;

export const PaddingRightIcon = styled(Icon)`
  padding-right: 0.3rem;
`;

export const ColorIcon = styled(Icon)`
  color: lightgray;
  transition: color 200ms ease-in-out;

  :hover {
    color: #323232;
  }
`;
type Props = {
  children?: ReactNode;
};
export const DivGrid = styled.div<Props>`
  display: flex;
  gap: 15px;
  align-items: center;
  margin-bottom: 1rem;
`;

export const HoverDangerDiv = styled.div<Props>`
  display: contents;
  color: lightgray;
  transition: color 200ms ease-in-out;

  :hover {
    color: #e85058;
  }
`;
